import { DateTime } from 'luxon';
import { FC } from 'react';
import styled from 'styled-components';

import { Td } from '@/components/Table';
import InvoiceAmountCells from '@/pages/FreelancerInvoices/components/InvoiceAmountCells';
import InvoiceFileCell from '@/pages/FreelancerInvoices/components/InvoiceFileCell';
import InvoicesStatusDot from '@/pages/FreelancerInvoices/components/InvoicesStatusDot';
import { FreelancerInvoiceSubmissionResource } from '@/types/resources';
import { InvoiceGenerationStatus } from '@/utils/enums';

import InvoiceRowActions from './InvoiceRowActions';

const actionableStatuses: InvoiceGenerationStatus[] = [
  InvoiceGenerationStatus.Pending,
  InvoiceGenerationStatus.Needs_Action,
  InvoiceGenerationStatus.Finances_Rejected,
];

const GrayTd = styled(Td)`
  color: ${({ theme }) => theme.colors.gray};
`;

const CompanyTd = styled(Td)`
  white-space: nowrap;
`;

const StatusTd = styled(Td)`
  position: sticky;
  box-shadow: -1px 0 0 ${({ theme }) => theme.colors.grayscale};
  background: ${({ theme }) => theme.colors.white};
  right: 56px;
  top: 0;
  bottom: 0;
  z-index: 1;
`;

interface Props {
  submission: FreelancerInvoiceSubmissionResource;
  showTeamLead: boolean;
  showRejectionReason: boolean;
  /** Invoice ID — only exists once the submission is approved. */
  showInvoiceNumber: boolean;
  showCommentColumns: boolean;
}

const FreelancersInvoicesApprovalTableRow: FC<Props> = ({
  submission,
  showTeamLead,
  showRejectionReason,
  showInvoiceNumber,
  showCommentColumns,
}) => (
  <tr>
    <GrayTd>
      {DateTime.fromISO(submission.createdAt).toFormat('yyyy/LL/dd')}
    </GrayTd>
    <Td>{submission.freelancer?.name ?? '-'}</Td>
    <CompanyTd>{submission.company?.name ?? '-'}</CompanyTd>
    {showTeamLead && <Td>{submission.teamLead?.name ?? '-'}</Td>}
    <InvoiceAmountCells submission={submission} />
    <Td>{submission.hours ?? '-'}</Td>
    <Td>{submission.comment ?? '-'}</Td>
    {showInvoiceNumber && <Td>{submission.invoice?.invoice_number ?? '-'}</Td>}
    <Td>{submission.paymentPurpose ?? '-'}</Td>
    <InvoiceFileCell
      submission={submission}
      freelancer={submission.freelancer}
    />
    {showRejectionReason && <Td>{submission.rejectionReason ?? '-'}</Td>}
    {showCommentColumns && <Td>{submission.teamLeadComment ?? '-'}</Td>}
    <StatusTd>
      <InvoicesStatusDot status={submission.status} />
    </StatusTd>
    <Td $actionsCol>
      {actionableStatuses.includes(submission.status) && (
        <InvoiceRowActions submission={submission} />
      )}
    </Td>
  </tr>
);

export default FreelancersInvoicesApprovalTableRow;
